import { USER_STUB } from './user-stub';

export const StubContext: CMxAPI.ContextAPI = {
  expiryTimeToLive: 600000,
  expiryDuration: 600000,
  activeContextId: null,
  contexts: [],
  user: USER_STUB
};

export const STUB_ORG_CONTEXT = {
  organizationId: 0,
  organizationName: '',
  organizationCode: '',
  organizationType: '',
  tenantId: '',
  parentLevel: 1,
  healthSystemTenantId: '',
  healthSystemCode: '',
  healthSystemName: '',
  displayName: '',
  cognitoEnabled: false,
  resources: [],
  serviceLines: []
};
